var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    stroke: "#E7EF7D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8253 24.7664V22.1497C44.8253 21.1903 44.0403 20.4053 43.0809 20.4053H39.5919C38.6325 20.4053 37.8475 21.1903 37.8475 22.1497V27.3831H22.1473V22.1497C22.1473 21.1903 21.3623 20.4053 20.4028 20.4053H16.9139C15.9544 20.4053 15.1694 21.1903 15.1694 22.1497V24.7664C13.582 25.9527 12.5527 27.8716 12.5527 29.9998C12.5527 32.1281 13.582 34.047 15.1694 35.2332V37.8499C15.1694 38.8094 15.9544 39.5944 16.9139 39.5944H20.4028C21.3623 39.5944 22.1473 38.8094 22.1473 37.8499V32.6165H37.8475V37.8499C37.8475 38.8094 38.6325 39.5944 39.5919 39.5944H43.0809C44.0403 39.5944 44.8253 38.8094 44.8253 37.8499V35.2332C46.4128 34.047 47.442 32.1281 47.442 29.9998C47.442 27.8716 46.4128 25.9527 44.8253 24.7664Z",
    fill: "#E7EF7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeights);
export default __webpack_public_path__ + "static/media/Weights.cd02a3b97eb4dc32011905ee0ef9d6b7.svg";
export { ForwardRef as ReactComponent };